export default "__VITE_ASSET__8dbbb69a__"